import { auth } from "./config";

async function INIT_FIREBASE_APP() {
  // if (Platform.OS == 'android') {
  //   firebase.firestore().settings({
  //     persistence: true
  //   })
  // }
}

async function SIGN_UP_FIREBASE(email, password) {
  try {
    const result = await auth().createUserWithEmailAndPassword(email, password);
    return { status: true, data: result, error: "" };
  } catch (error) {
    return authError(error);
  }
}

async function SIGN_IN_FIREBASE(email, password) {
  console.log("🔐 SIGN_IN_FIREBASE: Starting sign-in process");
  console.log("   Email:", email);
  console.log("   Password length:", password ? password.length : 0);
  
  try {
    // Check if auth is available
    const authInstance = auth();
    if (!authInstance) {
      console.error("❌ SIGN_IN_FIREBASE: Auth instance is not available");
      return { status: false, data: null, error: "Firebase Auth is not initialized" };
    }
    console.log("✅ SIGN_IN_FIREBASE: Auth instance available");
    
    // Check current auth state before sign-in
    const currentUser = authInstance.currentUser;
    console.log("   Current user before sign-in:", currentUser ? currentUser.email : "None");
    
    console.log("🔄 SIGN_IN_FIREBASE: Attempting sign-in with email and password...");
    const startTime = Date.now();
    
    const result = await authInstance.signInWithEmailAndPassword(email, password);
    
    const duration = Date.now() - startTime;
    console.log("✅ SIGN_IN_FIREBASE: Sign-in successful!");
    console.log("   Duration:", duration + "ms");
    console.log("   User ID:", result.user?.uid);
    console.log("   User Email:", result.user?.email);
    console.log("   Email Verified:", result.user?.emailVerified);
    console.log("   Provider:", result.user?.providerData?.[0]?.providerId || "email/password");
    console.log("   Creation Time:", result.user?.metadata?.creationTime);
    console.log("   Last Sign In:", result.user?.metadata?.lastSignInTime);
    
    return { status: true, data: result, error: "" };
  } catch (error) {
    console.error("❌ SIGN_IN_FIREBASE: Sign-in failed");
    console.error("   Error Code:", error.code);
    console.error("   Error Message:", error.message);
    console.error("   Error Name:", error.name);
    console.error("   Full Error:", error);
    
    // Log additional error details if available
    if (error.stack) {
      console.error("   Stack Trace:", error.stack);
    }
    
    // Check for common error scenarios
    if (error.code === "auth/user-not-found") {
      console.warn("⚠️ User not found - email may not be registered");
    } else if (error.code === "auth/wrong-password") {
      console.warn("⚠️ Wrong password provided");
    } else if (error.code === "auth/invalid-email") {
      console.warn("⚠️ Invalid email format");
    } else if (error.code === "auth/user-disabled") {
      console.warn("⚠️ User account has been disabled");
    } else if (error.code === "auth/too-many-requests") {
      console.warn("⚠️ Too many failed login attempts");
    } else if (error.code === "auth/network-request-failed") {
      console.warn("⚠️ Network error - check internet connection");
    } else if (error.code === "auth/invalid-api-key") {
      console.warn("⚠️ Firebase API key is invalid");
    } else if (error.code === "auth/app-not-authorized") {
      console.warn("⚠️ Firebase app is not authorized");
    }
    
    const errorResult = authError(error);
    console.log("   Returning error result:", errorResult);
    return errorResult;
  }
}

async function FIREBASE_UPDATE_PASSWORD(password) {
  try {
    const result = await auth().currentUser.updatePassword(password);
    return { status: true, data: result, error: "" };
  } catch (error) {
    return authError(error);
  }
}

async function SIGN_IN_GOOGLE() {
  try {
    const provider = new auth.GoogleAuthProvider();
    // const { idToken } = await GoogleSignin.signIn();
    // const googleCredential = auth.GoogleAuthProvider.credential();
    // const result = await auth().signInWithCredential(googleCredential);
    const result = await auth().signInWithPopup(provider);
    return { status: true, data: result, error: "" };
  } catch (error) {
    if (true) {
      return { status: false, data: null, error: null };
    } else {
      return { status: false, data: null, error: error.message };
    }
  }
}

async function SIGN_UP_APPLE() {
  try {
    const provider = new auth.OAuthProvider("apple.com");
    const result = await auth().signInWithPopup(provider);
    return { status: true, data: result, error: "" };
  } catch (err) {
    if (true) {
      return { status: false, data: null, error: null };
    } else {
      return { status: false, data: null, error: err.message };
    }
  }
}

async function REAUTH_FIREBASE_PASSWORD(email, password) {
  try {
    const credential = auth.EmailAuthProvider.credential(email, password);
    const result = await auth().currentUser.reauthenticateWithCredential(
      credential
    );
    return { status: true, data: result, error: "" };
  } catch (error) {
    return authError(error);
  }
}

async function REAUTH_WITH_GOOGLE() {
  try {
    const provider = new auth.GoogleAuthProvider();
    const result = await auth().currentUser.reauthenticateWithPopup(provider);
    return { status: true, data: result, error: "" };
  } catch (error) {
    return authError(error);
  }
}

async function REAUTH_WITH_APPLE() {
  try {
    const provider = new auth.OAuthProvider("apple.com");
    const result = await auth().currentUser.reauthenticateWithPopup(provider);
    return { status: true, data: result, error: "" };
  } catch (error) {
    return authError(error);
  }
}

async function LINK_EMAIL_PASSWORD_CREDENTIAL(email, password) {
  try {
    const credential = auth.EmailAuthProvider.credential(email, password);
    const result = await auth().currentUser.linkWithCredential(credential);
    return { status: true, data: result, error: "" };
  } catch (error) {
    return authError(error);
  }
}

async function LINK_GOOGLE_CREDENTIAL() {
  try {
    const provider = new auth.GoogleAuthProvider();
    const result = await auth().currentUser.linkWithPopup(provider);
    return { status: true, data: result, error: "" };
  } catch (error) {
    return authError(error);
  }
}

async function LINK_APPLE_CREDENTIAL() {
  try {
    const provider = new auth.OAuthProvider("apple.com");
    const result = await auth().currentUser.linkWithPopup(provider);
    return { status: true, data: result, error: "" };
  } catch (error) {
    return authError(error);
  }
}

async function UNLINK_PROVIDER(providerId) {
  try {
    const result = await auth().currentUser.unlink(providerId);
    return { status: true, data: result, error: "" };
  } catch (error) {
    return authError(error);
  }
}

async function UPDATE_FIREBASE_EMAIL(email) {
  try {
    await auth().currentUser.updateEmail(email);
    return { status: true, data: null, error: "" };
  } catch (error) {
    return authError(error);
  }
}

// async function SIGN_IN_APPLE() {
//   try {
//     const appleAuthRequestResponse = await appleAuth.performRequest({
//       requestedOperation: appleAuth.Operation.LOGIN,
//       requestedScopes: [appleAuth.Scope.EMAIL, appleAuth.Scope.FULL_NAME],
//     });

//     if (!appleAuthRequestResponse.identityToken) {
//       return {
//         status: false,
//         data: null,
//         error: "Apple Sign-In failed - no identify token returned",
//       };
//     }

//     const { identityToken, nonce, fullName } = appleAuthRequestResponse;
//     const appleCredential = auth.AppleAuthProvider.credential(
//       identityToken,
//       nonce
//     );
//     var result = await auth().signInWithCredential(appleCredential);
//     result.firstName = fullName.givenName;
//     result.lastName = fullName.familyName;
//     return { status: true, data: result, error: "" };
//   } catch (error) {
//     return { status: false, data: null, error: error.message };
//   }
// }

function authError(error) {
  const errorCode = error.code || "";
  let errorMessage = "";

  // Treat popup dismissal / cancellation as a silent no-op (no error toast).
  if (
    errorCode === "auth/popup-closed-by-user" ||
    errorCode === "auth/cancelled-popup-request" ||
    errorCode === "auth/user-cancelled"
  ) {
    return { status: false, data: null, error: null, code: errorCode, errorCode };
  }

  if (errorCode === "auth/email-already-in-use") {
    errorMessage = "That email address is already in use";
  } else if (errorCode === "auth/credential-already-in-use") {
    errorMessage = "Those credentials are already linked to another account";
  } else if (errorCode === "auth/provider-already-linked") {
    errorMessage = "This sign-in method is already linked to your account";
  } else if (errorCode === "auth/operation-not-allowed") {
    errorMessage = "This change is currently disabled. Please contact support.";
  } else if (errorCode === "auth/user-not-found") {
    errorMessage = "There is no user record corresponding to this identifier";
  } else if (errorCode === "auth/invalid-email") {
    errorMessage = "That email address is invalid!";
  } else if (errorCode === "auth/wrong-password") {
    errorMessage = "Password incorrect";
  } else if (errorCode === "auth/requires-recent-login") {
    errorMessage =
      "For your security, please sign in again before making this change.";
  } else {
    errorMessage = error.message || "An error occurred";
  }

  return {
    status: false,
    data: null,
    error: errorMessage,
    code: errorCode,
    errorCode: errorCode,
  };
}

export {
  INIT_FIREBASE_APP,
  SIGN_UP_FIREBASE,
  SIGN_IN_FIREBASE,
  SIGN_IN_GOOGLE,
  FIREBASE_UPDATE_PASSWORD,
  SIGN_UP_APPLE,
  REAUTH_FIREBASE_PASSWORD,
  REAUTH_WITH_GOOGLE,
  REAUTH_WITH_APPLE,
  LINK_EMAIL_PASSWORD_CREDENTIAL,
  LINK_GOOGLE_CREDENTIAL,
  LINK_APPLE_CREDENTIAL,
  UNLINK_PROVIDER,
  UPDATE_FIREBASE_EMAIL,
};
